(function () {
  function openModal() {
    return document.querySelector("product-modal[open]");
  }

  function closeFromEvent(event) {
    var modal = openModal();
    if (!modal || typeof modal.hide !== "function") return;
    var toggle = event.target.closest(".product-media-modal__toggle");
    var onMedia = event.target.closest(
      ".product-media-modal__content img, .product-media-modal__content video, .product-media-modal__content iframe, .product-media-modal__content model-viewer"
    );
    var inModal = event.target.closest("product-modal");
    if (!toggle && (onMedia || !inModal)) return;
    event.preventDefault();
    modal.hide();
  }

  document.addEventListener("click", closeFromEvent);
  document.addEventListener("touchend", closeFromEvent);
})();
